import { render, staticRenderFns } from "./SendInvitaionPopup.vue?vue&type=template&id=bd6a2134&scoped=true"
import script from "./SendInvitaionPopup.vue?vue&type=script&lang=js"
export * from "./SendInvitaionPopup.vue?vue&type=script&lang=js"
import style0 from "./SendInvitaionPopup.vue?vue&type=style&index=0&id=bd6a2134&prod&lang=scss&scoped=true"
import style1 from "./SendInvitaionPopup.vue?vue&type=style&index=1&id=bd6a2134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6a2134",
  null
  
)

export default component.exports